import { Component, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfirmBoxDialog } from '../ui/confirm-box/confirm-box.component';
import { ConfirmBoxModel } from '../ui/confirm-box/confirm-box.model';
import { MatDialog } from '@angular/material/dialog';

@Injectable()
export class CanNavigateGuard  {

    constructor(private dialog: MatDialog) { }
    canDeactivate(
        component: Component,
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | boolean {

        // const m: ConfirmBoxModel = new ConfirmBoxModel();
        // m.QuestionTitle = 'Etes-vous sûr de vouloir quitter cet écran, les données non sauvegardées seront perdues ?';
        // m.WithReason = false;
        // m.WithLengthValidation = false;
        // const dialogRef = this.dialog.open(ConfirmBoxDialog, {
        //     data: m,
        //     width: '777px',
        //     disableClose: true
        // });

        // return dialogRef.afterClosed().pipe(map(x => { if (x) { return true; } }));
        return true;
    }
}
